export default "__VITE_ASSET__CO00bYph__"